import { useEffect, useState } from "react";
import { tickerItems } from "@/mocks/heigua";

const navLinks = [
  { label: "快讯流", href: "#feed" },
  { label: "专题合集", href: "#collections" },
  { label: "栏目分区", href: "#zones" },
  { label: "加密专区", href: "#vault" },
  { label: "常见疑问", href: "#faq" },
];

export default function Topbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* 更新条压顶 */}
      <div className="bg-ink-950 text-cream-50/90">
        <div className="relative flex items-center gap-3 overflow-hidden px-4 md:px-6 py-2">
          <div className="flex shrink-0 items-center gap-2">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-ember-500 animate-pulse-dot" />
            </span>
            <span className="text-[11px] md:text-xs font-medium tracking-wide text-cream-50">正在更新</span>
            <span className="hidden h-4 w-px bg-cream-50/20 sm:block" />
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-10 pr-10">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-xs md:text-[13px] text-cream-50/80">
                  <span className={item.tag === "置顶" ? "text-ember-400" : item.tag === "热" ? "text-ember-500" : "text-leaf-500"}>
                    {item.tag}
                  </span>
                  <span className="truncate">{item.text}</span>
                </span>
              ))}
            </div>
          </div>
          <a
            href="#vault"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-xs font-medium text-ember-400 hover:text-ember-300 lg:flex"
          >
            <i className="ri-arrow-right-up-line" />
            进入加密专区
          </a>
        </div>
      </div>

      {/* 主导航 */}
      <nav
        className={`transition-colors duration-300 ${
          light ? "bg-transparent text-cream-50" : "bg-cream-50/95 text-ink-950 border-b border-cream-200"
        }`}
      >
        <div className="flex items-center justify-between px-4 md:px-6 py-3">
          <a href="#top" className="flex items-center gap-2.5">
            <span className={`flex h-9 w-9 items-center justify-center rounded-lg ${light ? "bg-ember-500 text-cream-50" : "bg-ember-500 text-cream-50"}`}>
              <i className="ri-water-flash-line text-lg" />
            </span>
            <span className="leading-none">
              <span className="block font-serif text-lg font-bold tracking-tight">吃瓜黑屋</span>
              <span className={`block text-[10px] tracking-widest ${light ? "text-cream-50/70" : "text-ink-600"}`}>GOSSIP VAULT</span>
            </span>
          </a>

          <div className="hidden items-center gap-8 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`whitespace-nowrap text-sm transition-colors ${light ? "text-cream-50/90 hover:text-ember-400" : "text-ink-700 hover:text-ember-600"}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#vault"
              className="hidden whitespace-nowrap rounded-md bg-ember-500 px-4 py-2 text-sm font-medium text-cream-50 hover:bg-ember-600 md:inline-flex"
            >
              <i className="ri-lock-2-line mr-1.5" />
              私密分享入口
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${light ? "text-cream-50" : "text-ink-950"}`}
            >
              <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <div className="border-t border-cream-200 bg-cream-50/95 px-4 pb-4 lg:hidden">
            <div className="flex flex-col gap-1 pt-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-2 py-2.5 text-sm text-ink-900 hover:bg-cream-100"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#vault"
                onClick={() => setOpen(false)}
                className="mt-1 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-ember-500 px-4 py-2.5 text-sm font-medium text-cream-50 hover:bg-ember-600"
              >
                <i className="ri-lock-2-line mr-1.5" />
                私密分享入口
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}